import { render, staticRenderFns } from "./FlyerStatusChip.vue?vue&type=template&id=7941295c"
import script from "./FlyerStatusChip.vue?vue&type=script&lang=js"
export * from "./FlyerStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports